<template>
	<footer class="footer">
		<ContainedSection :has-padding="false" custom-class="w-full pb-20">
			<div
				class="flex w-full flex-col items-center justify-center gap-4 md:flex-row"
			>
				<p class="order-1 text-sm text-gray-500 md:order-none">
					© {{ year }} Carbar Holdings Pty Ltd
				</p>
				<CarbarLink
					href="/terms-and-conditions"
					target="_blank"
					text="Terms and conditions"
					font-size="text-sm"
					class="inline-block"
					text-color="text-gray-500"
					underline-color="underline-gray-500"
				/>
				<CarbarLink
					href="/privacy-policy"
					target="_blank"
					text="Privacy policy"
					font-size="text-sm"
					class="inline-block"
					text-color="text-gray-500"
					underline-color="underline-gray-500"
				/>
				<CarbarLink
					href="/car-subscription/fees-and-charges"
					target="_blank"
					text="Fees and charges"
					font-size="text-sm"
					class="inline-block"
					text-color="text-gray-500"
					underline-color="underline-gray-500"
				/>
			</div>
		</ContainedSection>
	</footer>
</template>

<script setup>
import CarbarLink from '@/components/links/CarbarLink.vue'
import ContainedSection from '@/components/sections/ContainedSection.vue'

const year = new Date().getFullYear()
</script>
